<template>
    <layout-machine-introduction :unsaved-puri-count="unsavedPuriCount"
                                 :latest-image-id="latestImageId"
                                 :is-searchable="isSearchable"
                                 :machine-id="machineId"
                                 :section-title-list="sectionTitleList"
                                 youtube-url="https://youtu.be/tC7k4LgxQs0"
                                 :has-title-anchor-link="false">
        <template v-slot:content-1>
            <p class="img-01"><img :src="buildImgUrl('contents_01_01.png')" alt="なみだ袋と二重が際立つ立体eye"></p>
            <p class="img-02"><img :src="buildImgUrl('contents_01_02.png')" alt="透けツヤ感であか抜ける素肌っぽskin"></p>
            <p class="img-03"><img :src="buildImgUrl('contents_01_03.png')" alt="抜群に盛れて、雰囲気おしゃれな写り"></p>
            <p class="img-04"><img :src="buildImgUrl('contents_01_04.png')" alt="写りイメージ"></p>
        </template>
        <template v-slot:content-2>
            <p class="img-01"><img :src="buildImgUrl('contents_02_01.png')" alt="「頭の大きさ」や「目の角度」が新登場！"></p>
            <p class="img-02"><img :src="buildImgUrl('contents_02_02.png')" alt="大人気の小顔機能がさらに進化！"></p>
            <p class="img-03"><img :src="buildImgUrl('contents_02_03.png')" alt="Point 他にも嬉しいレタッチ機能がたくさんあるよ♡"></p>
            <p class="img-04"><img :src="buildImgUrl('contents_02_04.png')" alt="Point イメージ"></p>
            <p class="img-05"><img :src="buildImgUrl('contents_02_05.png')" alt="さらに調整バーで理想の盛れ感にできちゃう♡"></p>
        </template>
        <template v-slot:content-3>
            <p class="img-01"><img :src="buildImgUrl('contents_03_01.png')" alt="イマドキおしゃれなカラーが嬉しい♡盛れるメイクを豊富に搭載！"></p>
            <p class="img-02"><img :src="buildImgUrl('contents_03_02.png')" alt="イエベとブルベに分かれているからあなたに似合う色でもーっと盛れる"></p>
            <p class="img-03"><img :src="buildImgUrl('contents_03_03.png')" alt="イメージ"></p>
        </template>
        <template v-slot:content-4>
            <p class="img-01"><img :src="buildImgUrl('contents_04_01.png')" alt="New 自動で編集された 15秒動画がもらえるよ！"></p>
            <p class="img-02"><img :src="buildImgUrl('pom_GIF_1.gif')" alt="動画イメージ"></p>
            <p class="img-03"><img :src="buildImgUrl('pom_GIF_2.gif')" alt="文字なしver.も選べるから自分でアレンジもできちゃう♡"></p>
        </template>
        <template v-slot:content-5>
            <p class="img-01"><img :src="buildImgUrl('contents_05_01.png')" alt="シンプルおしゃれで超イマドキ♡シール、ロゴカラー、分割すうが選べるよ！"></p>
        </template>
    </layout-machine-introduction>
</template>

<script>
import LayoutMachineIntroduction from "../../templates/LayoutMachineIntroduction.vue";
import * as urlUtil from "../../../util/UrlUtil";
import {mapActions} from "vuex";

export default {
    name: "MachineTodayl1",
    components: { LayoutMachineIntroduction },
    data() {
        return {
            machineId: 144,
            sectionTitleList: [
                '1 抜群に盛れて、垢抜けるシャレ盛り',
                '2 とことんこだわれる 盛れるタッチ',
                '3 超豊富なイマドキ おしゃれメイク',
                '4 今日の思い出をカタチに残せる 15秒動画',
                '5 シンプルおしゃれな シャレシール'
            ],
        }
    },
    props: {
        /**
         * Headerコンポーネント用
         * 未保存プリ数
         */
        unsavedPuriCount: {
            type: String,
            required: true
        },
        /**
         * Headerコンポーネント用
         * 最新プリID
         */
        latestImageId: {
            type: String,
            required: true
        },
        /**
         * 当該機種が「遊べるお店を探す」によって検索可能であるかどうかを判定する.
         * toolboxから取得
         * 「遊べるお店を探す」表示判定
         */
        isSearchable: {
            type: Boolean,
            required: true
        },
    },
    mounted() {
        /**
         * TheHeader,TheFooterでstoreのaccountStatusを使用するため、予めstoreに保存しておく
         * FIXME:ここでの取得を忘れてもエラーが出ず気づかない可能性があるため、VOYAGERFRONT-5558で修正予定
         */
        this.getAccountStatus()
    },
    methods: {
        ...mapActions({
            getAccountStatus: 'AccountStoreV2/getAccountStatus'
        }),
        /**
         * 画像のURLを組み立てる
         * @param {string} imgName 画像名
         */
        buildImgUrl(imgName) {
            return urlUtil.imageUrlUtil.machineIntroductionImageUrl(String(this.machineId), imgName)
        },
        /**
         * cssのurl関数の呼び出し部分の含めた文字列を返す
         * styleタグ内でv-bindで使用することを想定している
         */
        buildStyleImgUrl(imageName) {
            const imgUrl = this.buildImgUrl(imageName)
            return `url(${imgUrl})`;
        },
    }
}
</script>

<style scoped lang="scss">
@use '../../../../scss/v2/base/variables';
@use "sass:math";

$deviceWidth: 750px;

:deep(*) {
    .c-machine-introduction {
        &-top {
            .btn-puri-list {
                width: math.percentage(math.div(162px, $deviceWidth));
                top: math.percentage(math.div(8px, $deviceWidth));
                left: math.percentage(math.div(16px, $deviceWidth));
            }

            .btn-shop-list {
                padding: 18px 0;
                background: variables.$color-machine-todayl1-shop;
                &-link {
                    margin: auto;
                    width: math.percentage(math.div(524px, $deviceWidth));
                    a {
                        display: block;
                    }
                }
            }

            .list-anchor-link {
                padding: 25px 0 35px;
                background: variables.$color-machine-todayl1;

                .img-link {
                    width: math.percentage(math.div(594px, $deviceWidth));
                }

                .img-line {
                    width: math.percentage(math.div(594px, $deviceWidth));
                    display: block;
                    margin: auto;
                }
            }
        }

        &-contents {
            .accordion-inner {
                text-align: center;

                &.cont-1 {
                    background: variables.$color-machine-todayl1 v-bind("buildStyleImgUrl('contents_01_05.png')") no-repeat bottom/contain;
                    padding-bottom: 50px;

                    .img-02 {
                        margin: 0 auto 24px;
                    }

                    .img-03 {
                        width: math.percentage(math.div(630px, $deviceWidth));
                        margin: 0 auto 26px;
                    }

                    .img-04 {
                        width: math.percentage(math.div(630px, $deviceWidth));
                        margin: 0 auto;
                    }
                }

                &.cont-2 {
                    background: variables.$color-machine-todayl1;
                    padding: 24px 0 30px;

                    .img-01,
                    .img-02 {
                        width: math.percentage(math.div(688px, $deviceWidth));
                        margin: 0 auto 12px;
                    }

                    .img-03 {
                        width: math.percentage(math.div(614px, $deviceWidth));
                        margin: 0 auto 12px;
                    }

                    .img-04 {
                        width: math.percentage(math.div(480px, $deviceWidth));
                        margin: 0 auto 8px;
                    }

                    .img-05 {
                        width: math.percentage(math.div(520px, $deviceWidth));
                        margin: 0 auto 8px;
                    }
                }

                &.cont-3 {
                    background: variables.$color-machine-todayl1-content3;
                    padding: 34px 0 38px;

                    .img-01 {
                        margin: 0 auto 18px;
                    }

                    .img-02 {
                        width: math.percentage(math.div(417px, $deviceWidth));
                        margin: 0 auto 10px;
                    }

                    .img-03 {
                        margin: 0 auto;
                        width: math.percentage(math.div(688px, $deviceWidth));
                    }
                }

                &.cont-4 {
                    background-image: v-bind("buildStyleImgUrl('contents_04_02.png')");
                    background-repeat: no-repeat;
                    background-size: cover;
                    padding: 20px 0 50px;

                    .img-01 {
                        width: math.percentage(math.div(448px, $deviceWidth));
                        margin: 0 auto 10px;
                    }

                    .img-02 {
                        width: math.percentage(math.div(644px, $deviceWidth));
                        margin: 0 auto 20px;
                    }

                    .img-03 {
                        width: math.percentage(math.div(587px, $deviceWidth));
                        margin: 0 auto;
                    }
                }

                &.cont-5 {
                    background: v-bind("buildStyleImgUrl('contents_05_02.png')") no-repeat bottom;
                    background-size: cover;
                    padding: 20px 0 32px;

                    .img-01 {
                        width: math.percentage(math.div(700px, $deviceWidth));
                        margin: 0 auto;
                    }
                }
            }
        }

        &-movie {
            padding: 20px 0 170px;
            background-image: v-bind("buildStyleImgUrl('movie_03.png')");
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;

            &-title {
                width: math.percentage(math.div(460px, $deviceWidth));
                margin: 0 auto 20px;
            }

            &-thumb {
                width: math.percentage(math.div(655px, $deviceWidth));
                margin: 0 auto;
            }
        }
    }
}

</style>
